@let orgChartId = store.orgChartIdSg();
@let hasSelectedNode =
  !!orgChartId &&
  !!store.orgChartFeature.cytoscapeManager.getSelectedNodeId({ orgChartId });

<div class="atn-summit-org-chart-tools">
  <div class="atn-summit-org-chart-tools__group">
    <!-- Add -->
    <atn-ds-button
      class="atn-summit-org-chart-tools__button"
      [isIcon]="true"
      type="white"
      (click)="
        orgChartId &&
          store.orgChartFeature.actions.addNode
            .from('OrgChartTools.AddButton.Clicked')
            .dispatch({ orgChartId })
      "
    >
      <i class="atn-icon atn-plus atn-blue"></i>
    </atn-ds-button>

    @if (hasSelectedNode) {
      <!-- Edit -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          orgChartId &&
            store.orgChartFeature.actions.editNode
              .from('OrgChartTools.EditButton.Clicked')
              .dispatch({ orgChartId })
        "
      >
        <i class="atn-icon atn-edit atn-blue"></i>
      </atn-ds-button>

      <!-- Delete -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          orgChartId &&
            store.orgChartFeature.actions.deleteNode
              .from('OrgChartTools.DeleteButton.Clicked')
              .dispatch({ orgChartId })
        "
      >
        <i class="atn-icon atn-eraser atn-red"></i>
      </atn-ds-button>
    }

    <!-- Undo -->
    @if (
      orgChartId &&
      store.orgChartFeature.selectors.canUndo({ orgChartId }).asSignal()
    ) {
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          orgChartId &&
            store.orgChartFeature.actions.undo
              .from('OrgChartTools.UndoButton.Clicked')
              .dispatch({ orgChartId })
        "
      >
        <i class="atn-icon atn-undo atn-blue"></i>
      </atn-ds-button>
    }

    <!-- Redo -->
    @if (
      orgChartId &&
      store.orgChartFeature.selectors.canRedo({ orgChartId }).asSignal()
    ) {
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          orgChartId &&
            store.orgChartFeature.actions.redo
              .from('OrgChartTools.RedoButton.Clicked')
              .dispatch({ orgChartId })
        "
      >
        <i class="atn-icon atn-redo atn-blue"></i>
      </atn-ds-button>
    }
  </div>

  <div class="atn-summit-org-chart-tools__group">
    <!-- Clear -->
    <atn-ds-button
      class="atn-summit-org-chart-tools__button"
      [isIcon]="true"
      type="white"
      (click)="confirmClearSg.set(true)"
    >
      <i class="atn-icon atn-trash atn-red"></i>
    </atn-ds-button>
    <!-- Clean Up -->
    <atn-ds-button
      class="atn-summit-org-chart-tools__button"
      [isIcon]="true"
      type="white"
      (click)="
        orgChartId &&
          store.orgChartFeature.actions.cleanUp
            .from('OrgChartTools.CleanUpButton.Clicked')
            .dispatch({ orgChartId })
      "
    >
      <i class="atn-icon atn-broom atn-blue"></i>
    </atn-ds-button>
    @if (orgChartId === 'current') {
      <!-- Create Proposal -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          orgChartId &&
            store.orgChartFeature.actions.propose
              .from('OrgChartTools.CreateProposalButton.Clicked')
              .dispatch('current')
        "
      >
        <i class="atn-icon atn-duplicate atn-blue"></i>
      </atn-ds-button>
    } @else if (orgChartId === 'proposed') {
      <!-- Approve Proposal -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          orgChartId &&
            store.orgChartFeature.actions.approveProposal
              .from('OrgChartTools.ApproveProposalButton.Clicked')
              .dispatch()
        "
      >
        <i class="atn-icon atn-approve"></i>
      </atn-ds-button>

      <!-- Reject Proposal -->
      <atn-ds-button
        class="atn-summit-org-chart-tools__button"
        [isIcon]="true"
        type="white"
        (click)="
          orgChartId &&
            store.orgChartFeature.actions.rejectProposal
              .from('OrgChartTools.RejectProposalButton.Clicked')
              .dispatch()
        "
      >
        <i class="atn-icon atn-close atn-red"></i>
      </atn-ds-button>
    }
  </div>
</div>
@if (confirmClearSg()) {
  <atn-ds-confirmation-overlay
    title="Clear Everything?"
    description="This will wipe out everything in this org chart. Are you sure you want to proceed?"
    (cancel)="confirmClearSg.set(false)"
    (confirm)="
      orgChartId &&
        store.orgChartFeature.actions.clear
          .from('OrgChartTools.ClearConfirmationButton.Clicked')
          .dispatch({ orgChartId });
      confirmClearSg.set(false)
    "
    confirmButtonText="Clear"
  />
}
